import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  // Main TTL KitStart popup texts
  servicesMainTitle: <PortalMessage id='t.app.kitstart.ttl.mainTitle' defaultMessage='Attiva i servizi aggiuntivi Nexi' />,
  servicesMainSubtitle: <PortalMessage id='t.app.kitstart.ttl.mainSubtitle' defaultMessage='Per <b>semplificare la gestione della tua attività</b> e <b>accogliere ogni esigenza dei tuoi clienti</b>, Nexi ti mette a disposizione i seguenti servizi.' />,

  // Service-specific texts
  servicesMicropaymentsTitle: <PortalMessage id='t.app.kitstart.ttl.micropayments.title' defaultMessage='Micropagamenti' />,
  servicesMicropaymentsDescription: <PortalMessage id='t.app.kitstart.ttl.micropayments.description' defaultMessage='Attiva Micropagamenti e risparmia sulle commissioni.' />,

  servicesPblTitle: <PortalMessage id='t.app.kitstart.ttl.pbl.title' defaultMessage='Pay-By-Link' />,
  servicesPblDescription: <PortalMessage id='t.app.kitstart.ttl.pbl.description' defaultMessage='Incassa con Pay-By-Link: invia un link di pagamento al tuo cliente.' />,

  servicesSoftposTitle: <PortalMessage id='t.app.kitstart.ttl.softpos.title' defaultMessage='SoftPOS di supporto' />,
  servicesSoftposDescription: <PortalMessage id='t.app.kitstart.ttl.softpos.description' defaultMessage="Accetta pagamenti contactless direttamente dal tuo telefono con l'App Nexi POS. SoftPOS gratuito per i primi 6 mesi, poi a soli 6€ al mese." />,

  // Funzioni dinamiche per supportare ISP_POS vs BACKUP_POS
  getServicesSoftposTitle: (serviceType) => {
    const isISP = serviceType === 'ISP_POS'
    return isISP
      ? <PortalMessage id='t.app.kitstart.ttl.softpos.title.isp' defaultMessage='SoftPOS aggiuntivo' />
      : <PortalMessage id='t.app.kitstart.ttl.softpos.title.nexi' defaultMessage='SoftPOS di supporto' />
  },

  getServicesSoftposDescription: (freeMonths, monthFee, serviceType) => {
    const months = freeMonths || '6'
    const fee = monthFee || (serviceType === 'ISP_POS' ? '5' : '6')
    const isISP = serviceType === 'ISP_POS'

    return (
      <PortalMessage
        id={isISP ? 't.app.kitstart.ttl.softpos.description.isp.dynamic' : 't.app.kitstart.ttl.softpos.description.nexi.dynamic'}
        defaultMessage={`Accetta pagamenti contactless direttamente dal tuo telefono con l'App Nexi POS. SoftPOS gratuito per i primi ${months} mesi, poi a soli ${fee}€ al mese.`}
        values={{ months, fee }}
      />
    )
  },

  // Action buttons
  servicesRequestNowLabel: <PortalMessage id='t.app.kitstart.ttl.requestNow' defaultMessage='Richiedili subito' />,
  servicesCloseLabel: <PortalMessage id='t.app.kitstart.ttl.close' defaultMessage='chiudi' />,

  // Badge labels per compatibilità con KitStartCard
  servicesFreeLabel: <PortalMessage id='t.app.kitstart.ttl.badge.free' defaultMessage='Gratuito' />,
  getFreeBadgeLabel: (freeMonths) => <PortalMessage id='t.app.kitstart.ttl.badge.freeMonths' defaultMessage={`Gratis ${freeMonths} mesi`} values={{ freeMonths }} />
}

export default formattedMessage
